import { ref } from 'vue'
import { post } from '../../../utils/index'

export function useSure({ formData, submitUrl }) {
  const sureLoading = ref(false)
  const sure = async (param, selections) => {
    if (!submitUrl.value) {
      return { ...formData.value, selections: selections?.value ?? [] }
    } else {
      sureLoading.value = true
      const params = { ...param, ...formData.value }
      const [res] = await post(submitUrl.value, params).catch(() => (sureLoading.value = false))
      sureLoading.value = false
      if (res) {
        return res
      }
    }
  }

  return {
    sureLoading,
    sure,
  }
}
